/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateMultipleKalendereintraegeDto } from '../../models/create-multiple-kalendereintraege-dto';
import { KalendereintragDto } from '../../models/kalendereintrag-dto';

export interface CreateKalendereintraegeFuerMitarbeiterUndZeitraum$Plain$Params {

/**
 * ID des Mitarbeiters
 */
  mitarbeiterId: string;
  
    /**
     * Daten für die Kalendereintraege
     */
    body?: CreateMultipleKalendereintraegeDto
}

export function createKalendereintraegeFuerMitarbeiterUndZeitraum$Plain(http: HttpClient, rootUrl: string, params: CreateKalendereintraegeFuerMitarbeiterUndZeitraum$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<KalendereintragDto>>> {
  const rb = new RequestBuilder(rootUrl, createKalendereintraegeFuerMitarbeiterUndZeitraum$Plain.PATH, 'post');
  if (params) {
    rb.path('mitarbeiterId', params.mitarbeiterId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<KalendereintragDto>>;
    })
  );
}

createKalendereintraegeFuerMitarbeiterUndZeitraum$Plain.PATH = '/v1/mitarbeiter{mitarbeiterId}/kalendereintraegeFuerZeitraum';
